import React from 'react';
import { PropTypes } from 'prop-types';
import Section from '../common/Section';
import ClientTableRow from './ClientTableRow';

const ClientsTable = ({ clients }) => {
    return (
        <Section className="table-content">
            <table>
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Company Name</th>
                        <th>Contact Name</th>
                        <th>Do Not Assign</th>
                        <th>White Gloves</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {clients.map(client =>
                        <ClientTableRow key={client.id} client={client} />
                    )}
                </tbody>
            </table>
        </Section>
    )
}

ClientsTable.propTypes = {
    clients: PropTypes.array.isRequired
}

export default ClientsTable;


// WEBPACK FOOTER //
// ./src/components/clients/ClientsTable.js